module.exports = __webpack_public_path__ + "img/img-facebook-bindnote.8887785b.png";